import { render, staticRenderFns } from "./FilterGoals.vue?vue&type=template&id=3a3bfa08"
import script from "./FilterGoals.vue?vue&type=script&lang=js"
export * from "./FilterGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports